export default __webpack_public_path__ + "static/media/background.fbac1948.jpg";